import React from 'react';
import { Link } from 'react-router-dom';

import { Button, CancelButton, Checkbox, Feature, FormField, ScrollableBox, SidebarHeader } from '@mssgme/ui';

import { useProductCollectionEdit } from './useProductCollectionEdit';
import { PageLayout } from '../../../../UI';
import { OldSaveButton } from '../UI';

import styles from './ProductCollectionEdit.scss';

export default function ProductCollectionEdit() {
    const {
        t,
        collectionId,
        collection,
        hasChanges,
        isFetching,
        isNew,
        errors,
        handleSubmit,
        handleChange,
        handleRemoveClick,
    } = useProductCollectionEdit();

    return (
        <PageLayout>
            <SidebarHeader
                heading={collectionId ? collection.name : t('ProductCollectionEdit.title')}
                leftButton={
                    <CancelButton
                        tag={Link}
                        to={collectionId ? `/p/products/collections/${collectionId}` : '/p/products/collections'}
                        styled="backIcon"
                    />
                }
                rightButton={hasChanges && <OldSaveButton isFetching={isFetching} onClick={handleSubmit} />}
            />
            <ScrollableBox>
                <Feature rule="collections:edit" subject={collection}>
                    <form noValidate onSubmit={handleSubmit}>
                        <div className={styles.checkboxContainer}>
                            <span>{t('ProductCollectionEdit.name')}</span>
                            {!isNew && collection.publishedProductsCount > 0 && (
                                <Checkbox
                                    checked={collection.published}
                                    name="published"
                                    onChange={handleChange}
                                    disabled={isFetching}
                                    styled="toggle"
                                />
                            )}
                        </div>
                        <FormField
                            name="name"
                            value={collection.name}
                            onChange={handleChange}
                            errors={errors.name && t(errors.name)}
                            maxLength={100}
                            disabled={isFetching}
                            autoFocus
                        />
                        {!isNew && !collection.default && (
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                <Button type="button" onClick={handleRemoveClick} btnStyle="danger">
                                    {t('button.remove')}
                                </Button>
                            </div>
                        )}
                    </form>
                </Feature>
            </ScrollableBox>
        </PageLayout>
    );
}
